module.exports = __webpack_public_path__ + "static/media/game_press_chair.d4fbc92e.png";